export const NUVEM_ENVIO_ORDERS_ROUTES = {
  ordersNuvemEnvioPrintLabelStatus: '/orders/nuvem-envio/print-label/status',
};
